import { mountStandaloneApp } from '@yuksalish/ui'
import MachinesPage from './pages/MachinesPage.vue'
import MachineDetailPage from './pages/MachineDetailPage.vue'
import EfficiencyPage from './pages/EfficiencyPage.vue'
import ShopfloorPage from './pages/ShopfloorPage.vue'
import BatchMachineAssignmentPage from './pages/BatchMachineAssignmentPage.vue'
import { operatorMessages } from './i18n'

mountStandaloneApp({
  code: 'machine-operator',
  title: 'Stanok operatori',
  description: 'Stanok holati, tayinlangan buyurtmalar, sozlamalar, hisoblagichlar, nosozliklar, to‘xtalishlar, ta’mirlash va samaradorlik.',
  messages: operatorMessages,
  accent: '#8a5a14',
  navigation: [
    {
      label: {
        en: operatorMessages.en.operator.nav.machines,
        ru: operatorMessages.ru.operator.nav.machines,
        uz: operatorMessages.uz.operator.nav.machines,
      },
      to: '/machines',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: operatorMessages.en.operator.nav.shopfloor,
        ru: operatorMessages.ru.operator.nav.shopfloor,
        uz: operatorMessages.uz.operator.nav.shopfloor,
      },
      to: '/shopfloor',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: operatorMessages.en.operator.nav.efficiency,
        ru: operatorMessages.ru.operator.nav.efficiency,
        uz: operatorMessages.uz.operator.nav.efficiency,
      },
      to: '/efficiency',
      permission: 'production_orders.view',
    },
  ],
  requiredPermissions: ['production_orders.view'],
  routes: [
    { path: '', redirect: '/machines' },
    { path: 'machines', component: MachinesPage, meta: { permission: 'production_orders.view' } },
    { path: 'machines/:id', component: MachineDetailPage, meta: { permission: 'production_orders.view' } },
    { path: 'shopfloor', component: ShopfloorPage, meta: { permission: 'production_orders.view' } },
    { path: 'shopfloor/batch-assign', component: BatchMachineAssignmentPage, meta: { permission: 'production_orders.manage' } },
    { path: 'efficiency', component: EfficiencyPage, meta: { permission: 'production_orders.view' } },
  ],
})
